import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

interface Props {
  isUserInfo: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'user-info',
  props: {
    isUserInfo: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isUserInfo: boolean
}




return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.isUserInfo)
      ? (_openBlock(), _createBlock(_component_el_popover, {
          key: 0,
          placement: "top",
          width: 300
        }, {
          reference: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "userInfo")
          ]),
          _: 3
        }))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ]))
}
}

})